import { Star, Quote } from "lucide-react";

const TestimonialCard = ({ testimonial, index }) => {
  return (
    <div
      data-testid={`testimonial-card-${testimonial.id}`}
      className="relative p-8 rounded-2xl transition-all duration-500 hover:-translate-y-1"
      style={{
        background: index % 2 === 0 ? "white" : "var(--ll-bg-secondary)",
        border: "1px solid var(--ll-border)",
      }}
    >
      <Quote
        size={32}
        className="mb-4 opacity-20"
        style={{ color: "var(--ll-accent)" }}
      />
      <p
        className="text-sm leading-relaxed mb-6"
        style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
      >
        "{testimonial.content}"
      </p>
      <div className="flex items-center justify-between">
        <div>
          <p
            className="text-sm font-medium"
            style={{ color: "var(--ll-text)", fontFamily: "'Outfit', sans-serif" }}
          >
            {testimonial.name}
          </p>
          <p
            className="text-xs"
            style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
          >
            {testimonial.role}
          </p>
        </div>
        <div className="flex gap-0.5">
          {Array.from({ length: testimonial.rating }).map((_, i) => (
            <Star key={`star-${testimonial.id}-${i}`} size={14} fill="var(--ll-accent)" style={{ color: "var(--ll-accent)" }} />
          ))}
        </div>
      </div>
    </div>
  );
};

const TestimonialsSection = ({ testimonials }) => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32"
      style={{ background: "var(--ll-bg-secondary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center mb-16">
          <p
            className="text-xs tracking-[0.3em] uppercase mb-4"
            style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
          >
            What People Say
          </p>
          <h2
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light"
            style={{ color: "var(--ll-text)" }}
          >
            Stories of{" "}
            <em className="italic" style={{ color: "var(--ll-text-secondary)" }}>
              Transformation
            </em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <TestimonialCard key={t.id} testimonial={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
